import BaseComponent from "@js/components/base_component.jsx";
import QrCode from "@js/components/widgets/qrcode.jsx";

class QrCodeScanner extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      displayRawCode: false,
    };
  }

  render() {
    return ( this.props.otp_secret && this.props.email ) ? (
      <div>
        <p>
          The QR code below contains the shared secret that should be set in
          your authenticator app. Most authenticator apps provide a way to
          scan this code. If you are unable to scan,&nbsp;
          <a href="#" onClick={ (e) => { e.preventDefault(); this._toggleCodeDisplay(e); } }>click here to get a text code</a> instead.
        </p>

        <div
          dangerouslySetInnerHTML={{ __html: this.props.hr }}
        />

        {
          this.state.displayRawCode ? (
            <div
              style={{
                textAlign: "center",
                fontSize: "32px",
                fontFamily: "monospace",
              }}
              id="qr-code-raw"
            >
              { this._newCodeRaw() }
            </div>
          ) : (
            <QrCode url={ this._newCodeUrl() } />
          )
        }
      </div>
    ) : (
      <div>
        QrCodeScanner requires otp_secret and email.
      </div>
    );
  }

  _toggleCodeDisplay() {
    this.setState({
      displayRawCode: !this.state.displayRawCode,
    });
  }

  _newCodeRaw() {
    return this.props.otp_secret;
  }

  _newCodeUrl() {
    if ( this.props.otp_secret && this.props.email ) {
      const email  = encodeURIComponent(this.props.email);
      const secret = encodeURIComponent(this.props.otp_secret);

      let name;
      if ( window.studioSystemName ) {
        name = encodeURIComponent(window.studioSystemName);
      } else {
        name = encodeURIComponent("GreenArrow");
      }

      return "otpauth://totp/" + name + ":" + email + "?secret=" + secret + "&issuer=" + name;
    } else {
      return null;
    }
  }

}

export default QrCodeScanner;
